/**
 * Email-format predicate used by account email verification. Deliberately loose —
 * the backend OTP + deliverability gate are the real validators; this only
 * blocks obviously-malformed input before a network call.
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
